module.exports = "query assignableUsers{assignableUsers{id name}}"